var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-container"},_vm._l((5),function(starIndex){return _c('i',{key:starIndex,staticClass:"fa-kit fa-trustpilot fa-xs rating",class:_vm.getStarClass(starIndex, Number(_vm.score))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }